<!-- https://markus.oberlehner.net/blog/transition-to-height-auto-with-vue/ -->
<template>
  <transition
    name="deploy"
    @enter="enter"
    @after-enter="afterEnter"
    @leave="leave"
    appear>
    <slot />
  </transition>
</template>

<script>
export default {
  name: "TransitionDeploy",
  props: {
    duration: {
      type: Number,
      default: 0.2
    }
  },
  methods: {
    enter(element) {
      element.style.transitionDuration = `${this.duration}s`;
      // We wait for the children to be all mounted
      requestAnimationFrame(() => {
        const { position, visibility } = element.style;
        element.style.position = "absolute";
        element.style.visibility = "hidden";
        element.style.height = "auto";

        const height = getComputedStyle(element).height;
        element.style.position = position;
        element.style.visibility = visibility;
        element.style.height = 0;
        // Trigger the animation.
        // We use `setTimeout` because we need
        // to make sure the browser has finished
        // painting after setting the `height`
        // to `0` in the line above.
        requestAnimationFrame(() => {
          element.style.height = height;
        });
      });
    },
    afterEnter(element) {
      element.style.height = "auto";
    },
    leave(element) {
      const height = getComputedStyle(element).height;
      element.style.height = height;
      requestAnimationFrame(() => {
        element.style.height = 0;
      });
    }
  }
};
</script>

<style>
.deploy-enter-active,
.deploy-leave-active {
  overflow: hidden;

  transition-property: all;
  transition-timing-function: ease-in-out;
}

.deploy-enter,
.deploy-leave-to {
  height: 0;
}
</style>

<style scoped>
* {
  transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 60rem;

  will-change: height;
}
</style>
